// @file Entrypoint for Features page
import { captureException } from 'bits/error_tracker'
import { setupVueApp } from 'bits/vue'
import FeaturesApp from 'vuecomponents/features_app.vue'
import { storeOptions } from 'vuexstore/home_store'

setupVueApp({
  el: '#features',
  rootComponent: FeaturesApp,
  storeOptions,
  initializeStore(store) {
    store.dispatch('initializeState').catch(captureException)
  },
}).catch(captureException)
